import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import BlogCardGrid from "../../design-system/templates/blog-card-grid"
import ExternalLinks from "../../external-links"

export default function BlogFeatures(props) {
  const query = useStaticQuery(graphql`
    query {
      resourcesFade: file(
        relativePath: {
          eq: "1_SOLUTIONS/Pre Built Applications - Internal Pages/Digital Directory/Desktop/fade_titles/resources_title.svg"
        }
      ) {
        publicURL
      }
      blogProduct: file(
        relativePath: {
          eq: "1_SOLUTIONS/Pre Built Applications - Internal Pages/Digital Directory/Desktop/desktop blog image 01.jpg"
        }
      ) {
        childImageSharp {
          fluid(maxWidth: 1440) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      blogVoice: file(
        relativePath: {
          eq: "1_SOLUTIONS/Pre Built Applications - Internal Pages/Digital Directory/Desktop/desktop blog image 02.jpg"
        }
      ) {
        childImageSharp {
          fluid(maxWidth: 1440) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      blogWayfinding: file(
        relativePath: {
          eq: "1_SOLUTIONS/Pre Built Applications - Internal Pages/Digital Directory/Desktop/desktop blog image 03.jpg"
        }
      ) {
        childImageSharp {
          fluid(maxWidth: 1440) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
    }
  `)

  const blogCardDetails = [
    {
      fluidImage: query.blogProduct.childImageSharp.fluid,
      title: "Product 101: Digital Directory Redesign",
      description:
        "Our Digital Directory product was originally designed to meet the needs of the search-first user and to showcase the map at the forefront.",
      link: ExternalLinks.hubspot.product101DirectoryRedesign,
    },
    {
      fluidImage: query.blogVoice.childImageSharp.fluid,
      title: "Feature 101: Directory Voice Assist",
      description:
        "Mappedin’s Directory Voice Assist is an audio-based assistant that provides a fast and touchless wayfinding experience on our Digital Directory product.",
      link: ExternalLinks.hubspot.product101Voice,
    },
    {
      fluidImage: query.blogWayfinding.childImageSharp.fluid,
      title: "7 Ways Digital Wayfinding Can Improve the Customer Experience",
      description:
        "In this article, we explore the different ways that digital wayfinding can be used to improve satisfaction among your visitors.",
      link: ExternalLinks.hubspot.verticalStadiumsBlogWayfinding,
    },
  ]

  return (
    <>
      <BlogCardGrid
        title="Learn More About Our Directory Product"
        blogCardDetails={blogCardDetails}
      />
    </>
  )
}
